import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewContactComponent } from './new-contact.component';
import { MdbGlobalModule } from '../mdb-global.module';

//input de ubicacion
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import {DxFilterBuilderModule, DxAccordionModule,DxFileUploaderModule,DxDropDownButtonModule, DxButtonGroupModule, DxAutocompleteModule, DxContextMenuModule, DxDropDownBoxModule, DxGanttModule, DxPopupModule, DxRadioGroupModule, DxSchedulerModule, DxScrollViewModule, DxSelectBoxModule, DxSliderModule, DxTabPanelModule, DxTextBoxModule, DxTreeViewModule, DxDataGridModule, DxTagBoxModule, DxDateBoxModule, DxCheckBoxModule, DxButtonModule } from 'devextreme-angular';


@NgModule({
  declarations: [
    NewContactComponent
  ],
  imports: [
    CommonModule,
    MdbGlobalModule,
    GooglePlaceModule,
    DxAccordionModule,
    DxFilterBuilderModule,
    DxFileUploaderModule,
    DxDropDownButtonModule, 
    DxButtonGroupModule,
    DxAutocompleteModule, 
    DxContextMenuModule, 
    DxDropDownBoxModule, 
    DxGanttModule, 
    DxPopupModule, 
    DxRadioGroupModule, 
    DxSchedulerModule, 
    DxScrollViewModule, 
    DxSelectBoxModule, 
    DxSliderModule, 
    DxTabPanelModule, 
    DxTextBoxModule, 
    DxTreeViewModule, 
    DxDataGridModule, 
    DxTagBoxModule,
    DxDateBoxModule,
    DxCheckBoxModule,
    DxButtonModule
  ],
  exports: [NewContactComponent]
})
export class NewContactModule { }
